import { render, staticRenderFns } from "./EditarConfiguracaoUpdateEnquetes.vue?vue&type=template&id=9072c582&scoped=true"
import script from "./EditarConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"
export * from "./EditarConfiguracaoUpdateEnquetes.vue?vue&type=script&lang=js"
import style0 from "./EditarConfiguracaoUpdateEnquetes.vue?vue&type=style&index=0&id=9072c582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9072c582",
  null
  
)

export default component.exports